<template>
  <div>
    <div class="swiper" v-show="true" ref="in">
      <div class="swiper-wrapper">
        <div class="swiper-slide"><img src="./assets/img/n0.png"/></div>
        <div class="swiper-slide"><img src="./assets/img/n1.png"/></div>
        <div class="swiper-slide"><img src="./assets/img/n2.png"/></div>
        <div class="swiper-slide"><img src="./assets/img/n3.png"/></div>
        <div class="swiper-slide"><img src="./assets/img/n4.png"/></div>
        <div class="swiper-slide"><img src="./assets/img/n5.png"/></div>
        <div class="swiper-slide"><img src="./assets/img/n6.png"/></div>
        <div class="swiper-slide"><img src="./assets/img/n7.png"/></div>
        <div class="swiper-slide"><img src="./assets/img/n8.png"/></div>
        <div class="swiper-slide"><img src="./assets/img/n9.png"/></div>
      </div>
    </div>
  </div>
</template>

<script src="//cos-r2cdn-game-1259807850.cos.ap-beijing.myqcloud.com/gamesite/act_myheroes_day/js/swiper-bundle.min.js"></script>
<script>
export default {
  name: "ImageNumber",
  data() {
    return {
      value: 0,
      mySwiper: null
    }
  },
  mounted() {
    this.mySwiper = new Swiper(this.$refs["in"], {
      direction: 'vertical', // 垂直切换选项
      loop: true, // 循环模式选项
      allowTouchMove: false,
    })
  },
  methods: {
    setValue: function (v) {
      this.value = parseInt(v)
      // this.$refs["in"].swipeTo(v + "")
      this.mySwiper.slideTo(this.value)
    }
  }
}
</script>

<style scoped>
.swiper {
  width: 70px;
  height: 108px;
}

.swiper-slide img {
  width: 70px;
  height: 108px;
}
</style>
